var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('PDFJSViewer',{attrs:{"path":("" + _vm.pdfPath),"fileName":("" + _vm.pdfFileName)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }